import React from 'react';



function blank() {
  
    

  return (
    <html>
    <body style={{background: "white",width:"360%"}}>
    
    </body>
    </html>  
  );
}

export default blank;
